import { Button } from 'react-bootstrap'
import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const StyledButtonContainer = styled(Button)`
  color: white;
  min-height: ${(props) => props.height}px;
  width: ${(props) => props.width};
  border-radius: 0;
  font-size: 18px;
  line-height: 23px;
  &:focus {
    outline: none;
  }
  &:hover {
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.16);
    /* transform: translateY(-3px); */
  }
  &.disabled:hover {
    transform: unset;
  }
  &.btn-blue {
    border: solid 1px ${colors.blueDark};
  }
  &.btn-transparent {
    border: solid 1px ${colors.white};
    background: transparent;
  }
  @media (max-width: ${breakpoints.xl}px) {
  }
`
